import { useEffect, useState } from 'react'

import { SEZNAM_MAPS_KEY } from '../../../ini.json'
import { useAppSelector } from '../../redux/hooks'

export const usePropertyDetailImagePanorama = (propertyId: string) => {
  const { lat, long } =
    useAppSelector(state => state.property.ruian.data?.definicniBod) ||
    ({ lat: null, long: null } as { lat: number | null; long: number | null })
  const ruianId = useAppSelector(state => state.property.ruian.data?.id)

  const [processedId, setProcessedId] = useState<string>()
  const [pano, setPano] = useState({ src: '', link: '' })

  useEffect(() => {
    if (propertyId === ruianId && propertyId !== processedId && lat && long) {
      const fetchPano = async () => {
        const url = `https://api.mapy.cz/v1/static/pano?width=1024&height=1024&lon=${long}&lat=${lat}&yaw=point&pitch=-0.2&fov=1.45&apikey=${SEZNAM_MAPS_KEY}`
        const response = await fetch(url)
        setPano({
          src: response.status === 200 ? response.url : '',
          link:
            response.status === 200
              ? `https://mapy.com/cs/zakladni?pid=&newest=1&x=${long}&y=${lat}&z=20&ovl=1`
              : `https://mapy.cz/zakladni?x=${long}&y=${lat}&z=18`,
        })
      }
      setProcessedId(propertyId)
      fetchPano()
    }
  }, [lat, long, processedId, propertyId, ruianId])

  return pano
}
